import { getSDKScript } from '../../utils/scriptHelper';
import { addScriptTag } from '../../utils/documentHelper';
import { env } from '../../constants';
import { SDK_INIT_OPTIONS } from './constants';

// Initialize SDK with options
export const initializeSDK = async (setSdkReady, setSdkError, setInitializingSDK, handleSdkStatusChange, handleAuthenticationStateChange) => {
  console.log('🔍 [SDKContext] Starting SDK initialization...');
  try {
    setInitializingSDK(true);
    setSdkError(null);

    if (window.nbc && window.nbc.identity) {
      console.log('🔍 [SDKContext] Initializing SDK with OAuth mode');

      // Set custom event attributes
      window.nbc.identity.customEventAttributes = { custom_app_data: 'web-backlot' };

      console.log('Current environment:', env);
      
      // Get SDK initialization options
      const initOptions = SDK_INIT_OPTIONS;

      // Initialize the SDK
      console.log('🔍 [SDKContext] Initializing SDK with options:', {
        ...initOptions,
        clientId: "backlotclub"
      });
      
      await window.nbc.identity.initialize("backlotclub", initOptions);
      console.log("SDK initialized successfully");

      // Set up event listeners
      window.nbc.identity.on('status', handleSdkStatusChange);
      window.nbc.identity.on('authenticationState', handleAuthenticationStateChange);

      setSdkReady(true);
    } else {
      throw new Error("SDK not found");
    }
  } catch (error) {
    console.error("Error initializing SDK:", error);
    setSdkError(error.message);
  } finally {
    setInitializingSDK(false);
  }
};

// Load SDK script
export const loadSDK = async (setSdkError, initializeSDKWithHandlers) => {
  console.log('🔍 [SDKContext] Starting SDK load...');
  try {
    if (!window.nbc?.identity) {
      const sdkLocation = getSDKScript();
      console.log('🔍 [SDKContext] Loading SDK from:', sdkLocation);
      
      // Create a promise that resolves when the script loads
      const loadPromise = new Promise((resolve, reject) => {
        addScriptTag(
          'nbc-identity-sdk-js',
          sdkLocation,
          { 
            async: false, 
            defer: false,
            onload: resolve,
            onerror: reject
          }
        );
      });

      // Wait for script to load
      await loadPromise;
      console.log('🔍 [SDKContext] SDK script loaded successfully');
      
      // Initialize SDK
      await initializeSDKWithHandlers();
    } else {
      console.log('🔍 [SDKContext] SDK already loaded, initializing...');
      await initializeSDKWithHandlers();
    }
  } catch (error) {
    console.error('Error loading SDK:', error);
    setSdkError(error.message);
  }
};
